export default "__VITE_ASSET___lqz23URe_hs5RkTvgMAIQ__"